import { IHomePageSubCategoryWithCoursesHit } from '@/types/search'
import { AvailableLanguages } from '../../shared/providers/LanguageSelectionProvider'

export type GroupedSubCategoryCourses<L extends AvailableLanguages> = Record<
  string,
  {
    courses: IHomePageSubCategoryWithCoursesHit<L>['course'][]
    name: string
  }
>

export function groupHitsBySubCategory<L extends AvailableLanguages>(
  hits: IHomePageSubCategoryWithCoursesHit<L>[]
): GroupedSubCategoryCourses<L> {
  return hits.reduce((acc, { course, subcategory }) => {
    if (acc[subcategory.id]) {
      acc[subcategory.id].courses.push(course)
    } else {
      acc[subcategory.id] = {
        courses: [course],
        name: subcategory.name,
      }
    }
    return acc
  }, {} as GroupedSubCategoryCourses<L>)
}
